import {useDispatch, useSelector} from "react-redux";
import {dialogs, hideChangeAvailableWSCounterDialog, loading, extendedOrganization} from "../../../store/slice";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Button, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {LocalSpinner} from "../../../../../../shared/components/Spinner";
import {UpdateAvailableWorkspacesCounter} from "../../../store/actions";

export const UpdateWorkspaceCounter = () => {
    const dispatch = useDispatch();
    const {changeAvailableWorkspaceDialog: {isOpen}} = useSelector(dialogs);
    const org = useSelector(extendedOrganization);
    const {isLoadingChangeWorkspaceCounter} = useSelector(loading);
    const [counter, setCounter] = useState<number>(0);

    const handleClose = () => {
        dispatch(hideChangeAvailableWSCounterDialog());
        setCounter(0);
    };

    const handleUpdate = () => {
        if(org){
            dispatch(UpdateAvailableWorkspacesCounter({id: org.id, newValue: counter}));
            setCounter(0);
        }
    }

    useEffect(() => {
        if(isOpen && org){
            setCounter(org.configuration.availableWorkspaceCount);
        }
        //eslint-disable-next-line
    }, [isOpen]);

    return(
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'xs'}>
            <DialogTitle>Available Workspaces counter</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Set workspace count below
                </DialogContentText>
                <TextField
                    type={'number'}
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Workspace counter"
                    fullWidth
                    variant="standard"
                    value={counter}
                    onChange={(e) => {setCounter(parseInt(e.target.value))}}
                />
            </DialogContent>
            {isLoadingChangeWorkspaceCounter ?
                <LocalSpinner />
                :
                <DialogActions>
                    <Button onClick={handleClose} color={'warning'}>Cancel</Button>
                    <Button onClick={handleUpdate} disabled={!org || (org && org.configuration.availableWorkspaceCount === counter)} color={'success'}>Update</Button>
                </DialogActions>
            }
        </Dialog>
    )
}